import { onrampComponents, onrampMeta } from './onramp';
import { appointmentComponents, appointmentMeta } from './appointment';

export { onrampComponents, appointmentComponents };

export const routeMeta = {
  ...onrampMeta,
  ...appointmentMeta
};
